
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";
import {
  coercePelletsChartMonths,
  DEFAULT_PELLETS_CHART_MONTHS,
  PelletsChartMonths,
} from "~/utils/pelletsChart";

export interface RangeOption {
  name: string;
  value: PelletsChartMonths;
}

const DEFAULT_RANGE_OPTIONS: RangeOption[] = [
  { name: "3 Monate", value: 3 },
  { name: "6 Monate", value: 6 },
  { name: "1 Jahr", value: 12 },
];

@Component({})
export default class PelletsChartTimeRangeSelector extends Vue {
  @Prop({ default: "pellets-chart-time-range" }) readonly id!: string;
  @Prop({ default: DEFAULT_PELLETS_CHART_MONTHS })
  readonly value!: PelletsChartMonths;
  @Prop({ default: () => DEFAULT_RANGE_OPTIONS })
  readonly options!: RangeOption[];

  @Emit("range-change")
  onChange(event: Event): PelletsChartMonths {
    const raw = Number((event.target as HTMLSelectElement).value);
    return coercePelletsChartMonths(raw);
  }
}
